module.exports = __webpack_public_path__ + "static/media/rachit.00446f48.jfif";